<template>
  <Animation name="fade">
    <div :class="['root', {'show-loader': loading}]" v-if="open">
      <slot />
      <div class="showLoader loader"></div>
    </div>
  </Animation>
</template>
 
<script>

import Animation from '../Animation'

export default {
  name: 'DialogFullscreen',

  components: { Animation },

  props: {
    loading: {
      type: Boolean,
      default: false
    },
    open: {
      type: Boolean,
      default: true
    },
    closeOnEsc: {
      type: Boolean,
      default: true
    },
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown)
    this.open && window.focus();
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.handleKeydown)
  },
  watch: {
    open () {
      window.focus()
    }
  },
  methods: {
    handleKeydown (e) {
      if(this.open && e.key === 'Escape' && this.closeOnEsc) {
        this.$emit('close')
      }
    }
  }
}

</script>

<style scoped>

.root {
  z-index: 10000;
  
  @apply
    fixed
    top-0
    left-0
    h-screen
    w-screen
    bg-white;
} 

.showLoader {
  @apply
    fixed
    top-0
    left-0
    h-screen
    w-screen
    invisible
    bg-white;
}

.root.show-loader .showLoader {
  @apply
    visible
}

</style>
